/* eslint-disable camelcase */
/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html} from 'lit';
import styles from './product-page-price-display.component.scss?as=stylesheet';
import {ringBuilderStore} from '../../data/ring-builder-store';
import {defineCustomElement, formatPrice} from 'extensions/utils';
import waitForExpression from '@mvps-genesis/wait-for-expression';

class ProductPagePriceDisplay extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			basePrice: {
				attribute: 'base-price',
				type: Number
			},
			price: {
				type: Number
			},
			store: {
				state: true,
				type: Object
			}
		};
	}

	constructor () {
		super();
	}

	async firstUpdated () {
		this.store = await ringBuilderStore;

		const didElem = document.querySelector('[name="DID"]');
		if (didElem && this.store.diamond?.product?.sku) {
			didElem.value = this.store.diamond.product.sku;
		}
		const diamondIDElem = document.querySelector('[name="Diamond_ID"]');
		if (diamondIDElem && this.store.diamond?.product?.id) {
			diamondIDElem.value = this.store.diamond.product.id;
		}
		const labDiamondElem = document.querySelector('[name="Lab_Diamond"]');
		if (labDiamondElem && this.store.diamond.product?.attributes?.labgrown) {
			labDiamondElem.value = this.store.diamond.product.attributes.labgrown;
		}
	}

	modifyResponseData (response) {
		this.price = response.data.price;
		this.basePrice = response.data.base_price;

		const basePrice = response.data.base_price + this.diamondPrice;
		const price = response.data.price + this.diamondPrice;

		response.data.base_price = basePrice;
		response.data.formatted_base_price = formatPrice(basePrice);
		response.data.price = price;
		response.data.formatted_price = formatPrice(price);
	}

	get diamondPrice () {
		return this.store?.diamond?.product?.price || 0;
	}

	connectedCallback () {
		super.connectedCallback();

		const self = this;

		waitForExpression(
			() => window.AttributeMachine?.prototype,
			() => {
				window.AttributeMachine.prototype.AttributeList_Load_Possible_Callback_Original_RB = window.AttributeMachine.prototype.AttributeList_Load_Possible_Callback;
				window.AttributeMachine.prototype.AttributeList_Load_Possible_Callback = function (response) {
					self.modifyResponseData(response);
					this.AttributeList_Load_Possible_Callback_Original_RB(response);
				};
			}
		);
	}

	disconnectedCallback () {
		super.disconnectedCallback();

		window.AttributeMachine.prototype.AttributeList_Load_Possible_Callback = window.AttributeMachine.prototype.AttributeList_Load_Possible_Callback_Original_RB;
	}

	get formattedPrice () {
		return formatPrice(this.price);
	}

	get formattedBasePrice () {
		return formatPrice(this.basePrice);
	}

	render () {
		// Review Page
		if (this.store?.review === '1') {
			return html`
				<div class="pricing review-pricing">
					<span class="price">${formatPrice(this.price + this.diamondPrice)}</span>
					<span class="pricing-breakdown">
						<span class="pricing-breakdown--diamond">Diamond ${formatPrice(this.diamondPrice)}</span>
						<span class="pricing-breakdown--sep">|</span>
						<span class="pricing-breakdown--diamond">Setting ${this.formattedPrice}</span>
					</span>
				</div>
			`;
		}

		if (this.basePrice >= this.price) {
			return html`
				<div class="pricing pricing-sale">
					<div class="price">Sale ${this.formattedPrice}</div>
					<div class="retail">Retail ${this.formattedBasePrice}</div>
				</div>
			`;
		}


		return html`
			<div class="pricing">
				<div class="price">Price ${this.formattedPrice}</div>
			</div>
		`;
	}
};

defineCustomElement('rb-product-page-price-display', ProductPagePriceDisplay);
